import { Box, Card, CardContent, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import IconComponent from "../../../common/components/IconComponent";
import Spinner from "../../../common/components/Spinner";
import { useErrorHandler } from "../../../common/hooks";
import { ValueCounterModel } from "../../Models/Dashboards/ValueCounterModel";
import formatPropertyValue from "../DataDisplay/formatPropertyValue";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";

const ValueCounterComponent: React.FC<IComponentProps<ValueCounterModel>> = ({ component, context }) => {
  const errorHandler = useErrorHandler();

  const [data, setData] = useState<any>(null);
  const [dataPending, setDataPending] = useState<boolean>(false);

  const [dataRefreshMarker, setDataRefreshMarker] = useState<number>(0);

  const handleLoadData = async () => {
    if (!component.GetData) {
      console.warn("GetData expression is not defined.");
      return;
    }

    setDataPending(true);
    try {
      const result = await context.Evaluator.evaluate(component.GetData, context);
      setData(result);
    } catch (error) {
      errorHandler(error);
    } finally {
      setDataPending(false);
    }
  };

  useEffect(() => {
    handleLoadData();
  }, [component.GetData]);

  const value = data ? formatPropertyValue(data, component.Property) : "-";

  const componentLayoutSx = getComponentLayout(component);

  return (
    <Card sx={componentLayoutSx}>
      <CardContent>
        {dataPending ? (
          <Spinner />
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography variant="h6" color="text.secondary" gutterBottom>
                {component.Property.Label}
              </Typography>
              <Typography variant="h4" component="div">
                {value}
              </Typography>
            </Box>
            {component.Property.IconName && (
              <Box sx={{ color: component.Property.Color || "primary.main", fontSize: 40 }}>
                <IconComponent iconName={component.Property.IconName} />
              </Box>
            )}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default ValueCounterComponent;
